module.exports = __webpack_public_path__ + "static/media/8_19.10086233.png";